import { Dropdown, Menu, Space } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import ThreeDot from './../../../../icons/Threedot.svg';
import { FileTypes } from '../false-deals-admin.types';
import AttachmentsList from './attachments-list';
import {validatePrivileges} from "mixins/helpers";

const dateFormat = 'DD.MM.YYYY';

const columnsTable = ({
    onUpdateButtonClick,
    onDeleteButtonClick,
    onShowDeleteReasonButtonClick,
    roles,
    privileges
}) => {
    return [
        {
            title: 'ИИН/БИН',
            dataIndex: 'iinBin',
            key: 'iinBin',
        },
        {
            title: 'Кем создан',
            key: 'createdBy',
            width: '200px',
            render: (_, item) => (item.createdByLastName || item.createdByFirstName)
                ? `${item.createdByLastName} ${item.createdByFirstName}`
                : item.createdBy
        },
        {
            title: 'ФИО/Наименование организации',
            dataIndex: 'fullName',
            key: 'fullName',
            width: '300px',
        },
        {
            title: 'Номер акта',
            dataIndex: 'actNumber',
            key: 'actNumber',
        },
        {
            title: 'Дата составления акта',
            dataIndex: 'preparationDate',
            key: 'preparationDate',
            width: '50px',
        },
        {
            title: 'Дата размещения',
            dataIndex: 'createdDate',
            key: 'createdDate',
            width: '50px',
        },
        {
            title: 'Судебный акт',
            dataIndex: FileTypes.ACT,
            key: FileTypes.ACT,
            render: (_, record) => <AttachmentsList files={record[FileTypes.ACT]} />,
        },
        {
            title: 'Список контрагентов',
            dataIndex: FileTypes.COUNTERPARTY,
            key: FileTypes.COUNTERPARTY,
            render: (_, record) => <AttachmentsList files={record[FileTypes.COUNTERPARTY]} />,
        },
        {
            title: 'Кем изменен',
            key: 'modifiedBy',
            width: '200px',
            render: (_, item) => (item.modifiedByLastName || item.modifiedByFirstName)
                ? `${item.modifiedByLastName} ${item.modifiedByFirstName}`
                : item.modifiedBy
        },
        {
            title: 'Дата редактирования',
            dataIndex: 'lastModifiedDate',
            key: 'updateDate',
            width: '50px',
            render: (a) => {
                const defaultFormat = dayjs(a);
                if (defaultFormat.isValid()) return defaultFormat.format(dateFormat);
                else return dayjs(a, 'YYYY-MM-DD').format(dateFormat);
            },
        },
        {
            title: 'Подтверждающий документ',
            dataIndex: FileTypes.CONFIRMATION,
            key: FileTypes.CONFIRMATION,
            render: (_, record) => <AttachmentsList files={record[FileTypes.CONFIRMATION]} />,
        },
        {
            title: 'Статус',
            dataIndex: 'status',
            key: 'status',
            render: (_, record) => {
                return record.deleted ? (
                    <div className="text-danger">Удалена</div>
                ) : (
                    <div className="text-success">Активна</div>
                );
            },
        },
        {
            title: 'Действия',
            dataIndex: 'operation',
            key: 'operation',
            render: (_, record) => (
                <Space size="middle">
                    <Dropdown
                        menu={{
                            items: record.deleted
                                ? [
                                      {
                                          key: 'view',
                                          label: (
                                              validatePrivileges(roles, privileges, 'PRIV_FALSE_DEAL_VIEW') && (
                                                  <Menu.Item
                                                      onClick={() =>
                                                          onShowDeleteReasonButtonClick(record)
                                                      }
                                                  >
                                                      Просмотреть обоснование
                                                  </Menu.Item>
                                              )
                                          ),
                                      },
                                  ]
                                : [
                                      {
                                          key: 'update',
                                          label: (
                                              validatePrivileges(roles, privileges, 'PRIV_FALSE_DEAL_EDIT') && (
                                                  <Menu.Item
                                                      onClick={() => onUpdateButtonClick(record)}
                                                  >
                                                      Редактировать
                                                  </Menu.Item>
                                              )
                                          ),
                                      },
                                      {
                                          key: 'delete',
                                          label: (
                                              validatePrivileges(roles, privileges, 'PRIV_FALSE_DEAL_DELETE') && (
                                                  <Menu.Item
                                                      onClick={() => onDeleteButtonClick(record)}
                                                  >
                                                      Удалить
                                                  </Menu.Item>
                                            )
                                          ),
                                      },
                                  ],
                        }}
                    >
                        <ThreeDot />
                    </Dropdown>
                </Space>
            ),
        },
    ];
};

export default columnsTable;
